import { isRequired } from '../../utils.js';

var mode = function mode() {
  if (window.matchMedia('screen and (max-width:51.9rem)').matches) {
    return 'mobile';
  }

  return 'desktop';
};
/**
 * NOTE: `user_agent` is part of the schema but is intentionally left out as this value is inserted
 * by the pixiedust endpoint on the backend.
 */


var commonWebClientMetadata = (function (_ref) {
  var _ref$page_edition = _ref.page_edition,
      page_edition = _ref$page_edition === void 0 ? isRequired('page_edition') : _ref$page_edition;
  return function () {
    return {
      mode: mode(),
      page_edition: page_edition,
      viewport_size: {
        width: Number(window.screen.width),
        height: Number(window.screen.height)
      }
    };
  };
});

export default commonWebClientMetadata;
